import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_REG_MEH_ROUTES as ROUTES } from './utils'
import { CreateElement } from 'vue'
import { lkStoreModule } from '@/store/modules/lk'
import createFormRoutes from '@/views/LKMunMeh/Form/routes'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'reg-meh',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "reg-meh-lk.store" */
        './store'
      )
      registerModule(options)

      const storeModule = lkStoreModule.context(options.store)

      const promises = [
        storeModule.actions.getTopics().catch(() => ({})),
        storeModule.actions.getRoadmapsCount().catch(() => ({})),
        storeModule.actions.getRegMehCount().catch(() => ({})),
      ]

      await Promise.all(promises)

      next()
    },
    component: {
      name: 'LKRegMehLayout',
      render: (h: CreateElement) => h(
        'keep-alive',
        {
          props: {
            include: [
              'LKRegMehList',
              'LKRegMehView',
            ],
          },
        },
        [h('router-view')],
      ),
    },
    children: [
      ...createFormRoutes(options),
      {
        path: ':id',
        name: ROUTES.VIEW,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "reg-meh-lk.view" */
          './LKRegMehView.vue'
        ),
      },
      {
        path: '/',
        name: ROUTES.LIST,
        component: (): PromiseVue => import(
          /* webpackChunkName: "reg-meh-lk.list" */
          './LKRegMehList.vue'
        ),
      },

    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
